/**
 * "Action required" filter group. Hosts sibling buckets that each render independently; today the
 * Manual Actions bucket and the Errors bucket.
 *
 * The group is Open-tab only (its buckets describe open RMAs) and shows when at least one bucket is
 * present. Each bucket shows purely on the presence of its own rms-api data — there is no feature
 * check here. rms-api is the single gate for the Manual Actions bucket (ET-3119): it omits
 * `manual_actions` unless the merchant is enrolled in the automation-tracking beta AND its
 * `rma_actions` backfill has finished, so a client-side flag check could only disagree with it.
 */
import { observer } from "mobx-react";
import "./rma-list-actions-status-filter.scss";
import { IRmaListTab } from "../../../../../services/api/rma-list-service";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import RmaListErrorsBucket from "../rma-list-errors-bucket/rma-list-errors-bucket";
import RmaListManualActionsBucket from "../rma-list-manual-actions-bucket/rma-list-manual-actions-bucket";
import RmaListActionsStatusFilterHeader from "./rma-list-actions-status-filter-header/rma-list-actions-status-filter-header";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled: boolean;
    onApply: () => void;
}

const RmaListActionsStatusFilter: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled, onApply }) => {
    const isOpenTab = rmaListFiltersStore.currentTab === IRmaListTab.STATUS_GROUP_OPEN;

    const showManualActionsBucket = rmaListFiltersStore.hasManualActionsBucket;
    const showErrorsBucket = rmaListFiltersStore.hasErrorBucket;

    if (!isOpenTab || (!showManualActionsBucket && !showErrorsBucket)) {
        return null;
    }

    return (
        <div className="rma-list-actions-status-filter">
            <RmaListActionsStatusFilterHeader />
            {showManualActionsBucket && (
                <RmaListManualActionsBucket rmaListFiltersStore={rmaListFiltersStore} disabled={disabled} onApply={onApply} />
            )}
            {showErrorsBucket && (
                <RmaListErrorsBucket rmaListFiltersStore={rmaListFiltersStore} disabled={disabled} onApply={onApply} />
            )}
        </div>
    );
});

export default RmaListActionsStatusFilter;
